import type { DocMigration } from "../docMigration";

const prevDefaultCategories = [
  "CASEWORK",
  "COLUMN",
  "DOORS",
  "PORCH",
  "PROPS",
  "RAILING",
  "ROOF",
  "STAIR",
  "WAINSCOTING",
  "WALLS",
  "WINDOWS",
  "SLAB",
  "STEM_WALL",
  "FOUNDATION_CURB",
  "FOUNDATION_FOOTING",
  "FOUNDATION_PIER",
  "TRIM",
];

const CEILING = "CEILING";
const FLOOR_FRAMING = "FLOOR_FRAMING";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_393: DocMigration = {
  maxSchemaVersion: "0.0.393",
  description: "Migrate 3D view templates to include ceilings and floor framing by default",
  apply(json: any) {
    for (const viewTemplateId in json.viewTemplates) {
      const viewTemplate = json.viewTemplates[viewTemplateId];
      if (
        viewTemplate.viewType === "SECTION_VIEW" ||
        viewTemplate.viewType === "ELEVATION_VIEW" ||
        viewTemplate.viewType === "VIEW_3D"
      ) {
        let addNewDefaultCategories = true;
        for (const category of prevDefaultCategories) {
          // Only enable the new categories in case all of the old default categories are already enabled.
          if (!viewTemplate.categories.includes(category)) {
            addNewDefaultCategories = false;
            break;
          }
        }
        if (addNewDefaultCategories) {
          viewTemplate.categories.push(CEILING, FLOOR_FRAMING);
        }
      }
    }
    return json;
  },
};

export default migration_0_0_393;
